module.exports = __webpack_public_path__ + "media/images/download/e-book13-9c2f332a45b0419634246e13a2c22508.png";